module.exports = __webpack_public_path__ + "fonts/Adelle_Semibold.efd93511.woff";